export const CRISIS_MANAGER = {
  TITLE: 'Gestor de Crisis',
  TABS: {
    COMMITEE: 'Comité',
    INCIDENTS: 'Incidencias',
  },
  ESCALATION_ORDER: {
    TITLE: 'Orden de Escalamiento',
  },
  CONTACT_GROUPS: {
    COMMITTEE: {
      TITLE: 'Comité',
      BADGE: 'Comité',
    },
    QALEA: {
      TITLE: 'Qalea',
      BADGE: 'MSSP',
    },
    ADD_BUTTON: 'Añadir',
  },
  CONTACT_ITEM: {
    BADGES: {
      COMMITTEE: 'Comité',
      MSSP: 'MSSP',
    },
    ALERT_BUTTON: 'Alertar',
  },
  CONTACT_FORM: {
    ADD: {
      TITLE: 'Añadir Nuevo Contacto',
      DESCRIPTION: 'Añade un nuevo miembro al comité de gestión de crisis.',
    },
    EDIT: {
      TITLE: 'Editar Contacto',
      DESCRIPTION: 'Actualiza la información del contacto.',
    },
    FIELDS: {
      NAME: {
        LABEL: 'Nombre',
        REQUIRED: '*',
      },
      TITLE: {
        LABEL: 'Título',
        REQUIRED: '*',
      },
      PHONE: {
        LABEL: 'Teléfono',
        REQUIRED: '*',
      },
      EMAIL: {
        LABEL: 'Email',
        REQUIRED: '*',
      },
      ON_CALL_HOURS: {
        LABEL: 'Horario de Guardia',
        REQUIRED: '*',
      },
    },
    ACTIONS: {
      SAVE: 'Guardar Cambios',
      ADD: 'Añadir Contacto',
      CANCEL: 'Cancelar',
    },
  },
  DELETE_DIALOG: {
    TITLE: 'Eliminar Contacto',
    DESCRIPTION: (contactName: string) =>
      `¿Estás seguro de que quieres eliminar a <strong>${contactName}</strong> del comité? Esta acción no se puede deshacer.`,
    ACTIONS: {
      CANCEL: 'Cancelar',
      DELETE: 'Eliminar',
    },
  },
  ALERT_DIALOG: {
    TITLE: 'Alertar Contacto',
    DESCRIPTION: 'Escalar alerta a:',
    WARNING: 'El contacto será notificado inmediatamente.',
    SUCCESS: (contactName: string) => `Alerta escalada a ${contactName}`,
    ACTIONS: {
      CANCEL: 'Cancelar',
      CONFIRM: 'Confirmar Alerta',
    },
  },
  INCIBE_FORM: {
    TITLE: 'Notificación a INCIBE-CERT',
    PREVIEW_TITLE: 'Vista Previa del Email - Notificación a INCIBE-CERT',
    PREVIEW_DESCRIPTION: 'Revisa los detalles del reporte de incidente antes de enviar',
    FIELDS: {
      EMAIL: {
        LABEL: 'Tu Dirección de Email',
        PLACEHOLDER: 'tu@empresa.com',
        DESCRIPTION: 'Esta dirección se usará como remitente en el email',
        REQUIRED: '*',
      },
      CLASSIFICATION: {
        LABEL: 'Clasificación del Incidente',
        PLACEHOLDER: 'Seleccionar clasificación...',
        REQUIRED: '*',
      },
      INCIDENT_TYPE: {
        LABEL: 'Tipo de Incidente',
        PLACEHOLDER: 'Seleccionar tipo...',
        REQUIRED: '*',
      },
      SECTOR: {
        LABEL: 'Sector',
        PLACEHOLDER: 'Ej: Financiero, Salud, Tecnología, etc.',
        REQUIRED: '*',
      },
      DESCRIPTION: {
        LABEL: 'Descripción del Incidente',
        PLACEHOLDER: 'Descripción detallada del incidente...',
        REQUIRED: '*',
      },
      AFFECTED_SYSTEMS: {
        LABEL: 'Sistemas Afectados',
        PLACEHOLDER: 'Lista de sistemas, servidores o recursos afectados...',
      },
      ATTACK_VECTOR: {
        LABEL: 'Vector de Ataque',
        PLACEHOLDER: 'Ej: Phishing, Exploit, Fuerza bruta, etc.',
      },
      IMPACT: {
        LABEL: 'Impacto',
        PLACEHOLDER: 'Descripción del impacto en la organización...',
      },
      IOCS: {
        LABEL: 'Indicadores de Compromiso (IOCs)',
        PLACEHOLDER: 'IPs, dominios, hashes, URLs, etc.',
      },
      MITIGATION: {
        LABEL: 'Acciones de Mitigación',
        PLACEHOLDER: 'Medidas tomadas para mitigar el incidente...',
      },
    },
    ACTIONS: {
      REVIEW: 'Revisar Reporte',
      BACK: 'Volver a Editar',
      SUBMIT: 'Enviar a INCIBE-CERT',
    },
    SUCCESS_MESSAGE: 'Reporte de incidente enviado a INCIBE-CERT exitosamente',
    PREVIEW: {
      FROM: 'De',
      TO: 'Para',
      SUBJECT: 'Asunto',
      EMAIL_TO: 'incibe-cert@incibe.es',
      SUBJECT_TEXT: 'Reporte de Incidente de Seguridad',
      INCIDENT_DETAILS: 'Detalles del Incidente',
      NOT_PROVIDED: 'No proporcionado',
      UNCLASSIFIED: 'Sin clasificar',
    },
  },
}
